import { Button as StageTenButton } from "@lazarentertainment/web-design-system/components/button"
import { ComponentPropsWithoutRef, forwardRef } from "react"

export const buttonVariants = [
  "primary",
  "secondary",
  "outline",
  "overlay",
  "tertiary-gray",
] as const

export const buttonSizes = ["sm", "md", "lg"] as const

export type ButtonProps = Omit<
  ComponentPropsWithoutRef<typeof StageTenButton>,
  "variant" | "size"
> & {
  /**
   * Indicates which variant of the button is being used. A variant represents
   * essentially different ways of styling the button.
   *
   * @default "primary"
   */
  variant?: (typeof buttonVariants)[number]

  /**
   * Indicates the size of this button. Arbitrary sizes are not allowed so that
   * buttons are always given one of a narrow set of sizes that fit within
   * the design system
   *
   * @default "md"
   */
  size?: (typeof buttonSizes)[number]
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { className, variant = "primary", size = "md", children, ...props },
    ref,
  ) => {
    return (
      <StageTenButton
        className={`button ${className}`}
        data-variant={variant}
        data-size={size}
        ref={ref}
        {...props}
      >
        {children}
      </StageTenButton>
    )
  },
)
